export default function FlowSection() {
  const steps = [
    {
      number: 1,
      title: 'お問い合わせ・ご予約',
      description: 'お電話またはWebフォームからお気軽にご連絡ください。ご都合の良い日時をお伺いします。',
      icon: 'ri-phone-line',
      duration: '約5分'
    },
    {
      number: 2,
      title: 'ご訪問・ご挨拶',
      description: 'ご予約の日時に吉田がご自宅までお伺いします。笑顔でご挨拶させていただきます。',
      icon: 'ri-home-smile-line',
      duration: '当日〜翌日'
    },
    {
      number: 3,
      title: '査定・お見積もり',
      description: '一点一点丁寧に査定し、その場で買取価格をご提示。ご納得いただけるまでご説明いたします。',
      icon: 'ri-search-eye-line',
      duration: '約30分'
    },
    {
      number: 4,
      title: 'お支払い・完了',
      description: 'ご了承いただけましたら、その場で現金にてお支払い。お品物をお預かりして完了です。',
      icon: 'ri-hand-coin-line',
      duration: '約10分'
    }
  ];

  return (
    <section id="flow" className="py-24 bg-white relative">
      {/* Subtle wood texture overlay */}
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'repeating-linear-gradient(90deg, #3E2723 0px, #3E2723 1px, transparent 1px, transparent 40px)'
      }}></div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-[#3E2723] mb-4">
            ご利用の流れ
          </h2>
          <p className="text-2xl text-[#00A58E] font-semibold">
            たった4ステップで完了！
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Step Card */}
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border-2 border-gray-100 h-full">
                {/* Number Badge */}
                <div className="w-16 h-16 flex items-center justify-center bg-[#00A58E] rounded-full mb-6 mx-auto">
                  <span className="text-3xl font-bold text-white">{step.number}</span>
                </div>

                {/* Icon */}
                <div className="w-16 h-16 flex items-center justify-center bg-[#E0F2F1] rounded-full mb-4 mx-auto">
                  <i className={`${step.icon} text-3xl text-[#00A58E]`}></i>
                </div>

                {/* Title */}
                <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
                  {step.title}
                </h3>

                {/* Duration Badge */}
                <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#FF6B35] to-[#F7931E] text-white px-4 py-1 rounded-full text-sm font-semibold mb-3 mx-auto block w-fit">
                  <i className="ri-time-line"></i>
                  <span>{step.duration}</span>
                </div>

                {/* Description */}
                <p className="text-sm text-gray-600 leading-relaxed text-center">
                  {step.description}
                </p>
              </div>

              {/* Arrow (except for last item) */}
              {index < steps.length - 1 && (
                <div className="hidden md:flex absolute top-1/3 -right-4 z-10 w-8 h-8 items-center justify-center">
                  <i className="ri-arrow-right-line text-3xl text-[#00A58E]"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center mt-16">
          <a 
            href="#contact" 
            className="inline-block bg-gradient-to-r from-[#FF6B35] to-[#F7931E] text-white px-12 py-5 rounded-full text-xl font-semibold hover:shadow-xl transition-all shadow-lg whitespace-nowrap"
          >
            今すぐ無料相談を申し込む
          </a>
          <p className="mt-4 text-gray-600">
            <i className="ri-time-line mr-2"></i>
            通常24時間以内にご返信いたします
          </p>
        </div>
      </div>
    </section>
  );
}